class LoyaltyPoints extends HTMLElement {
  connectedCallback() {
    this.perEuro = parseFloat(this.dataset.pointsPerEuro) || 1;

    // The variant switch only re-renders a few targeted ids, so the points
    // have to follow the selected variant's price on their own.
    if (typeof subscribe !== "function" || typeof PUB_SUB_EVENTS === "undefined") return;

    this.sectionId = this.closest("product-info")?.dataset?.section;

    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event?.data?.sectionId;
      if (this.sectionId && sectionId && this.sectionId !== sectionId) return;

      const target = this.querySelector("[data-loyalty-points]");
      if (!target) return;

      // Prefer the value Liquid rendered for the new variant when the section fetch carries it.
      const source = event?.data?.html?.querySelector?.("loyalty-points [data-loyalty-points]");
      if (source) {
        target.textContent = source.textContent;
        return;
      }

      const variant = event?.data?.variant;
      if (!variant) return;
      target.textContent = Math.floor((Number(variant.price) / 100) * this.perEuro);
    });
  }

  disconnectedCallback() {
    if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
  }
}

if (!customElements.get("loyalty-points")) {
  customElements.define("loyalty-points", LoyaltyPoints);
}
